import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators, compose } from 'redux'
import { connect } from 'react-redux'
import { fetchClientList } from '../modules/client'
import { fetchSingleClientPermissions } from '../modules/permission'
import FormDialog from '../components/formDialog'
import Messages from '../constants/messages'
import {
  fetchRoles,
  postRole,
  putRole,
  removeRole } from '../modules/role'
import { paginationChangePage, paginationChangeRowsPerPage } from '../modules/table'
import { required } from '../utils/validationRules'
import { setFormValues, showDialog, resetForm, setConfirmationItem } from '../modules/formDialog'
import TableDisplay from '../components/tableDisplay'
import withStyles from 'material-ui/styles/withStyles'
import { unflagDataRefresh } from '../modules/refresh'


const PROP_TYPES = {
  classes: PropTypes.object.isRequired,
  roles: PropTypes.array.isRequired,
  totalCount: PropTypes.number.isRequired
}

const styles = theme => ({
  root: {
    maxWidth: 975,
    margin: 'auto'
  },
  pageMessage: theme.pageMessage
})

export class Roles extends Component {

  roleTableButtons = [
    {
      buttonName: 'ModeEdit',
      callback: (role) => {
        this.props.setFormValues(role)
        this.props.showDialog(true, 'edit')
      },
      tooltip: Messages['tooltips']['EDIT']
    },
    {
      buttonName: 'Clear',
      callback: (role) => {
        this.props.setConfirmationItem(role)
        this.props.showDialog(true, 'delete')
      },
      tooltip: Messages['tooltips']['DELETE']
    }
  ]

  roleTableOptions = [
    {
      name: 'name',
      friendlyName: Messages['uiComponents']['TABLE_NAME_COLUMN'],
      displayType: 'string',
    },
    {
      name: 'applicationId',
      friendlyName: Messages['uiComponents']['TABLE_APPLICATION_ID_COLUMN'],
      displayType: 'string'
    },
    {
      name: 'description',
      friendlyName: Messages['uiComponents']['TABLE_DESCRIPTION_COLUMN'],
      displayType: 'string'
    }
  ]

  dialogOptions = {
    new: [
      {
        type: 'textField',
        name:'name',
        friendlyName: Messages['uiComponents']['ROLES_NAME_INPUT_FIELD'],
        validationRules: [required]
      },
      {
        type: 'textField',
        name:'description',
        friendlyName: Messages['uiComponents']['ROLES_DESCRIPTION_INPUT_FIELD'],
        validationRules: [required]
      },
      {
        type: 'permissionMultiSelectField',
        name:'permissions',
        friendlyName: Messages['uiComponents']['ROLES_PERMISSION_SELECT_FIELD'],
        validationRules: [required]
      }
    ],
    edit: [
      {
        type: 'textField',
        name:'name',
        friendlyName: Messages['uiComponents']['ROLES_NAME_INPUT_FIELD'],
        validationRules: [required]
      },
      {
        type: 'textField',
        name:'description',
        friendlyName: Messages['uiComponents']['ROLES_DESCRIPTION_INPUT_FIELD'],
        validationRules: [required]
      },
      {
        type: 'permissionMultiSelectField',
        name:'permissions',
        friendlyName: Messages['uiComponents']['ROLES_PERMISSION_SELECT_FIELD'],
        validationRules: [required]
      }
    ],
    delete: [
      {
        type: 'confirmation',
        name:'name',
        friendlyName: 'Delete',
        confirmationType: 'delete'
      }
    ]
  }

  getProgressIndicatorText(formType) {
    const { isFetch } = this.props
    switch(formType) {
      case 'new':
        if (isFetch) {
          return Messages['uiComponents']['LOADING_MSG']
        }
        return Messages['uiComponents']['CREATING_MSG']
      case 'edit':
        return Messages['uiComponents']['UPDATING_MSG']
      case 'delete':
        return Messages['uiComponents']['DELETING_ROLE_MSG']
      default:
        return Messages['uiComponents']['LOADING_MSG']
    }
  }

  setTitle(formType) {
    switch(formType) {
      case 'new':
        return Messages['uiComponents']['CREATE_ROLE_TITLE']
      case 'edit':
        return Messages['uiComponents']['EDIT_ROLE_TITLE']
      case 'delete':
        return Messages['uiComponents']['DELETE_ROLE_TITLE']
      default:
        return ''
    }
  }

  componentDidMount() {
    const {
      applicationId,
      clientList,
      dataRefreshRequired,
      fetchClientList,
      fetchRoles,
      fetchSingleClientPermissions,
      unflagDataRefresh } = this.props
    fetchSingleClientPermissions(applicationId)
    .then(() => {
      if (clientList.length === 0) {
        fetchClientList()
      }
      if (dataRefreshRequired) {
        unflagDataRefresh('roles')
        fetchRoles(true)
      }
    })
  }

  handleSubmit(values) {
    const {
      applicationId,
      confirmationItem,
      formType,
      postRole,
      putRole,
      removeRole,
      resetForm } = this.props
    switch(formType) {
      case 'new':
        postRole({...values, applicationId})
        resetForm()
        break
      case 'edit':
        putRole({...values, applicationId})
        resetForm()
        break
      case 'delete':
        removeRole(confirmationItem)
        resetForm()
        break
      default:
        break
    }
  }

  render() {
    const {
      applicationId,
      classes,
      clientList,
      confirmationItem,
      fetchRoles,
      formValues,
      roles,
      isLoadingDialog,
      open,
      formType,
      paginationChangePage,
      paginationChangeRowsPerPage,
      paginationPage,
      paginationRowsPerPage,
      resetForm,
      showDialog,
      singleClientPermissions,
      totalCount } = this.props

    return (
      <section className={classes.root}>
        <FormDialog
          buttonLabel={Messages['uiComponents']['CREATE_ROLE_BUTTON']}
          data={{permissions: singleClientPermissions, clientList, appId: applicationId}}
          dialogOptions={this.dialogOptions[formType] || []}
          handleFormSubmit={(values) => this.handleSubmit(values)}
          infoText={this.getProgressIndicatorText(formType)}
          isLoading={isLoadingDialog}
          initialValues={formValues}
          enableReinitialize={true}
          confirmationItem={confirmationItem}
          open={open}
          showDialog={showDialog}
          resetFormValues={resetForm}
          title={this.setTitle(formType)}/>
        <p className={classes.pageMessage}>{Messages['pageHeaders']['ROLES_PAGE_MSG']}</p>
        <TableDisplay
          data={roles}
          fetchDataCallback={fetchRoles}
          page={paginationPage}
          paginationChangePage={paginationChangePage}
          paginationChangeRowsPerPage={paginationChangeRowsPerPage}
          rowsPerPage={paginationRowsPerPage}
          serverSidePagination={true}
          tab="role"
          tableButtons={this.roleTableButtons}
          tableOptions={this.roleTableOptions}
          totalCount={totalCount}
          type="role" />
      </section>
    )
  }
}

Roles.propTypes = PROP_TYPES

const mapStateToProps = state => ({
  applicationId: state.appContext.appInfo.id,
  clientList: state.client.clientList,
  confirmationItem: state.formDialog.confirmationItem,
  dataRefreshRequired: state.refresh.dataRefreshRequired.roles,
  formType: state.formDialog.formType,
  formValues: state.formDialog.formValues,
  isFetch: state.loading.isFetch,
  isLoadingDialog: state.loading.isLoadingDialog,
  open: state.formDialog.open,
  paginationPage: state.table.paginationPage.role,
  paginationRowsPerPage: state.table.paginationRowsPerPage.role,
  roles: state.role.roles,
  singleClientPermissions: state.permission.singleClientPermissions,
  totalCount: state.role.totalCount
})

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchClientList,
  fetchRoles,
  fetchSingleClientPermissions,
  showDialog,
  paginationChangePage,
  paginationChangeRowsPerPage,
  postRole,
  putRole,
  setConfirmationItem,
  setFormValues,
  removeRole,
  resetForm,
  unflagDataRefresh }, dispatch)

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(Roles)
